import React, { useState, useMemo, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Search, X } from "lucide-react";
import { allProducts, mugs, giftBoxes } from "../mock";

const searchable = () => [
  ...allProducts.map((p) => ({ ...p, kind: "Shirt", to: `/shop/${p.slug}` })),
  ...mugs.map((m) => ({ ...m, kind: "Mug", to: `/cups` })),
  ...giftBoxes.map((g) => ({ ...g, kind: "Gift Box", to: `/gifts` })),
];

export default function SearchBox({ onClose }) {
  const [q, setQ] = useState("");
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);

  const results = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return [];
    return searchable()
      .filter((p) => (p.title || "").toLowerCase().includes(needle) ||
                     (p.category || "").toLowerCase().includes(needle) ||
                     (p.desc || "").toLowerCase().includes(needle))
      .slice(0, 24);
  }, [q]);

  return (
    <div className="fixed inset-0 z-[100] bg-[color:var(--dms-navy)]/60 backdrop-blur-sm" onClick={onClose}>
      <div className="max-w-3xl mx-auto mt-24 bg-white rounded-2xl shadow-2xl overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3 px-5 py-4 border-b border-[color:var(--dms-navy)]/10">
          <Search className="w-5 h-5 text-[color:var(--dms-navy)]/60" />
          <input ref={inputRef} value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Search mugs, verses, shirts, gift boxes…"
            className="flex-1 bg-transparent focus:outline-none text-[color:var(--dms-navy)] text-lg" />
          <button onClick={onClose} className="text-[color:var(--dms-navy)]/60 hover:text-[color:var(--dms-navy)]" aria-label="Close">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="max-h-[60vh] overflow-y-auto">
          {q.trim() === "" ? (
            <div className="p-8 text-center text-sm text-[color:var(--dms-navy)]/60">Try “God-fidence”, “mug”, “polo”, or any verse keyword.</div>
          ) : results.length === 0 ? (
            <div className="p-8 text-center text-sm text-[color:var(--dms-navy)]/60">No matches for “<span className="text-[color:var(--dms-navy)]">{q}</span>” — try a different word.</div>
          ) : (
            <ul className="divide-y divide-[color:var(--dms-navy)]/5">
              {results.map((r, i) => (
                <li key={`${r.kind}-${r.id || i}`}>
                  <Link to={r.to} onClick={onClose} className="flex items-center gap-4 p-4 hover:bg-[color:var(--dms-cream-2)] transition-colors">
                    <div className="w-14 h-14 rounded-lg overflow-hidden bg-[color:var(--dms-peach-light)]/40 flex-shrink-0">
                      <img src={r.img} alt="" className="w-full h-full object-cover" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="kicker text-[10px]">{r.kind} · {r.category}</p>
                      <p className="font-serif text-[color:var(--dms-navy)] text-base leading-snug truncate mt-1">{r.title}</p>
                    </div>
                    <p className="font-serif text-[color:var(--dms-navy)] text-lg">{r.price}</p>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
